
import React from 'react';
import '../../../styles/admin/leaflet.css';
interface Props {
  show: boolean;
  onClose: () => void;
  ipData: {
    lat: number;
    lon: number;
    ip?: string;
    city?: string;
    country?: string;
  };
}

const IpMapModal = ({ show, onClose, ipData }: Props) => {
  if (!show) return null;

  const mapUrl = `https://maps.google.com/maps?q=${ipData.lat},${ipData.lon}&z=15&output=embed`;

  return (
    <div className="modal-backdrop-custom">
      <div className="modal-custom">
        <div className="modal-header">
          <h5>IP Location</h5>
          <button onClick={onClose}>✕</button>
        </div>
        <iframe
          title="IP Location Map"
          src={mapUrl}
          width="100%"
          height="400px"
          style={{ border: 0, borderRadius: 8 }}
          allowFullScreen
        />
        <div style={{ marginTop: 8 }}>
          <strong>{ipData.ip}</strong> — {ipData.city}, {ipData.country}
        </div>
      </div>
    </div>
  );
};

export default IpMapModal;
